import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Dialog } from '@sato/components';

import { ROUTES } from '@routes/routes.constants';
import { authStore } from '@stores/authStore';
import { localizationStore } from '@stores/localization';

interface LogoutModalProps {
  onClose: () => void;
  isOpen: boolean;
}

/** Logs out automatically after this time */
const AUTOMATIC_LOGOUT_TIMEOUT = 10_000;
const INITIAL_COUNTDOWN = AUTOMATIC_LOGOUT_TIMEOUT / 1000;

export const LogoutModal = ({ isOpen, onClose }: LogoutModalProps) => {
  const t = localizationStore.getTranslation;

  const [countdown, setCountdown] = useState(INITIAL_COUNTDOWN);
  const navigate = useNavigate();

  const onLogout = async () => {
    // Navigate directly to login page without redirect query parameter
    await authStore.logout();
    navigate(ROUTES.LOGIN);
    onClose();
  };

  useEffect(() => {
    if (!isOpen) return;

    const timeoutInstance = setTimeout(
      () => onLogout(),
      AUTOMATIC_LOGOUT_TIMEOUT
    );

    const countdownInstance = setInterval(() => {
      setCountdown((value) => value - 1);
    }, 1000);

    return () => {
      clearTimeout(timeoutInstance);
      clearInterval(countdownInstance);
      setCountdown(INITIAL_COUNTDOWN);
    };
  }, [isOpen, onClose]);

  return (
    <Dialog
      isOpen={isOpen}
      hideCloseButton
      onOpenChange={(value) => !value && onClose()}
      heading={t('logout_modal_title')}
      body={t('logout_confirm_body', { countdown })}
      actionButton={{
        children: t('logout'),
        onClick: onLogout,
      }}
      backButton={{
        children: t('cancel'),
      }}
    />
  );
};
